<template>
  <div class="bar-page">
    
      <Header />
      <SmoothScroll>
          <PageTitle :pageTitle="'ჟუჟუნას ბარი'" :titleColor="'white'" :bgColor="'#F49CB8'"/>
          <HistoryBlockBar />
          <Configurator />
        <Footer />
      </SmoothScroll>
  </div>
</template>

<script>
import SmoothScroll from '@/components/SmoothScroll';
import HistoryBlockBar from '@/components/smartComponents/HistoryBlockBar';
import Configurator from '@/components/smartComponents/Configurator';

import PageTitle from '@/components/layout/PageTitle';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
export default {
components: {SmoothScroll, Header, PageTitle, Footer, HistoryBlockBar, Configurator},
}
</script>

<style>

</style>